import { FC } from 'react'
import { RenderIf } from 'components/RenderIf'
import { Button } from 'featureSliced/entities/Button'
import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'
import { IProduct } from 'featureSliced/shared/store/reducers/CategoriesReducer/types'
import { GridDiv } from 'featureSliced/shared/utils/gridDiv'
import { StickyCtaBar } from '../ComonProduct/styled'
import { TableStatuses } from 'featureSliced/shared/store/reducers/QRMenuTableReducer/types'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { handleLocalStorage } from 'featureSliced/shared/hooks/handleLocalStorage'
import {
  getItemLeadDays,
  isItemLeadDaysExceeded,
} from 'featureSliced/shared/utils/itemLeadDays'
import { templateNeedsCompose } from 'featureSliced/shared/utils/menuStepChoices'

type ASPFProps = {
  product: IProduct
  moveToNext: () => void
}

export const AddSpecialProductFooter: FC<ASPFProps> = ({
  product,
  moveToNext,
}) => {
  // Hooks
  const t = useTranslations()
  const tableStatus = useMySelector((state) => state.qrMenuTable.tableStatus)
  const bookingVariant = useMySelector((state) => state.app.menu.bookingVariant)
  const disabledByMobileWaiter = useMySelector(
    (state) => state.app.menu.disabledByMobileWaiter
  )
  // D3: a set/menu is gated by its OWN lead time only — components inside are not
  // individually checked (confirmed with Pavel, QRM-639).
  const isLeadDaysExceeded = isItemLeadDaysExceeded({
    leadDays: getItemLeadDays(product.ClickCollectLeadDaysCount),
    pickUpTime: handleLocalStorage('pickUpTime'),
  })
  return (
    <RenderIf
      condition={
        navigator.onLine &&
        (templateNeedsCompose(product) ||
          !!product.innerCategoryItems?.length) &&
        (bookingVariant === 2 || process.env.REACT_APP_IS_CLIC === '1') &&
        !disabledByMobileWaiter &&
        tableStatus !== TableStatuses.BUSY &&
        !product.soldOut &&
        !isLeadDaysExceeded
      }
    >
      <StickyCtaBar>
        <GridDiv gc="1 / -1">
          <Button buttonType="common" width="100%" onClick={moveToNext}>
            {t('products.compose')}
          </Button>
        </GridDiv>
      </StickyCtaBar>
    </RenderIf>
  )
}
